import React, { Component } from 'react';
import { Popconfirm, Button, Spin, Icon, message, Modal, Tooltip, Switch } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import { InformModify, ConfigMainCrc } from './Widget';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
import UpdateAssignWeight from './UpdateAssignWeight';

const monthFormat = 'YYYY-MM';

class Filter extends Component {

    disabledDate = (current) => {
        const { date } = this.props;
        const curNum = Number(current.format('YYYYMM'));
        const startNum = Number(moment(date).add(-3, 'M').startOf('month').format('YYYYMM'));
        return curNum < startNum
    }

    render() {
        const { ...rest } = this.props;
        const { siteId, curRole } = sessionStorage;
        const filters = [{
            name: '工作日期',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: curRole === 'CRC' ? this.disabledDate : undefined,
            }
        }, {
            name: '|',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: curRole === 'CRC' ? this.disabledDate : undefined,
            }
        }, {
            name: '状态',
            key: 'workStatus',
            type: 'select',
            typeProperty: {
                list: [
                    { label: '未确认', value: 'UNVERIFY' },
                    { label: '未确认(待修改)', value: 'UNVERIFY_UNHAND' },
                    { label: '未确认(已修改)', value: 'UNVERIFY_HANDED' },
                    { label: '已确认', value: 'VERIFY' },
                ],
            }
        }];
        if (siteId == 0) {
            filters.push({
                name: '中心',
                key: 'investigationSite',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'searchKey',
                    style: {width: 160},
                    placeholder: '输入中心编号/名称检索',
                    params: {limit: 20},
                    url: API_URL.site.list,
                    config: { id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' },
                }
            });
        }
        filters.push({
            name: '录入者',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.team.userlist,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        });
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class Summary extends Component {
    constructor(props) {
        super(props);
        const { siteId } = sessionStorage;
        const { userFteSummaryId } = props;
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {
                investigationSiteId: siteId > 0 ? siteId : '',
                begin: moment().format(monthFormat),
                end: moment().format(monthFormat),
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            userFteSummaryId,
            maxMonth: '',
            isConfigMainCrcDate: false,
            currentDate: '',
            flag: false,
            checked: false,
        };
    }

    componentDidMount() {
        this.loadData();
        this.queryDate();
        this.queryInvestigationStageByInvId();
        this.getDate();
        this.getOpenSwitchPremission();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, userFteSummaryId } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.execute.queryUserFteSummary,
            data: {
                offset: current,
                limit: pageSize - 1,
                ...sortParams,
                ...params,
                userFteSummaryId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount + ((totalCount / (pageSize - 1)) | 0);
                datas.forEach(i => i.date = `${i.yearNum}-${i.monthNum > 9 ? i.monthNum : `0${i.monthNum}`}`);
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                    userFteSummaryId: '',
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryDate = () => {
        const options = {
            url: API_URL.user.queryPmScoreGradeDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const maxMonth = date;
                this.setState({ maxMonth });
            },
        };
        $.sendRequest(options);
    }

    getDate = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                // 判断系统时间是否处于每月的27号~29号24点，2月份的截止最后1天24点
                const isConfigMainCrcDate = this.isDateInTargetRange(date);
                const currentDate = moment(date).format('YYYY.M');
                this.setState({ isConfigMainCrcDate, currentDate, date });
            },
        };
        $.sendRequest(options);
    }

    getOpenSwitchPremission = () => {
        const options = {
            method: 'POST',
            url: API_URL.execute.openSwitchPremission,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { flag } = res;
                this.setState({ flag }, () => {
                    this.getQuerySwitch();
                });
            }
        };
        $.sendRequest(options);
    }
    getQuerySwitch = ()=>{
        const options = {
            method: 'POST',
            url: API_URL.execute.querySwitch,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { investigationManHourSwitch } = res;
                // 当 investigationManHourSwitch 为 null/undefined 时，默认关闭
                this.setState({ checked: (investigationManHourSwitch && investigationManHourSwitch.openFlag) || false });
            }
        };
        $.sendRequest(options);
    }

    isDateInTargetRange = (date) => {
        const targetDate = moment(date);
        const month = targetDate.month() + 1; // 月份（1-12）

        // 处理 2 月：判断是否为当月最后一天 24 点
        if (month === 2) {
          const lastDayOfFeb = moment(targetDate).endOf('month').date(); // 2 月最后一天
            return targetDate.isSame(moment(targetDate).date(lastDayOfFeb).endOf('day'), 'minute');
        }

        // 处理其他月份：判断是否在 27 号 00:00 至 29 号 24:00（即 30 号 00:00）
        const start = moment(targetDate).date(27).startOf('day');
        const end = moment(targetDate).date(29).endOf('day'); // 29 号 24:00 实际等于 30 号 00:00
        return targetDate.isBetween(start, end, null, '[]'); // 闭区间包含边界
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.export.exportUserFteSummary;
        ExportUtil.export({ ...sortParams, ...params }, pagination, url);
    }

    cancelConfig = (record) => {
        const { userId, yearNum, monthNum, investigationSiteId } = record;
        const options = {
            method: 'POST',
            url: API_URL.execute.cancelSiteMainCrc,
            data: {
                userId,
                yearNum,
                monthNum,
                investigationSiteId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    markModifyComplete = (record) => {
        const options = {
            method: 'POST',
            url: API_URL.manhour.remarkManHourNoticeModify,
            data: {
                ...record,
                hourType: 'investigation',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    confirm = hourId => {
        const options = {
            url: API_URL.execute.comfirmUserFteMonthOne,
            data: {
                hourId,
                hourType: 'investigation',
            },
            dataType: 'json',
            doneResult: res => {
                const { pmConfirmPercent } = res;
                if( pmConfirmPercent ) {
                    Modal.warning({
                        content: '该项目的“截止本月末完工%”=100%，请至我的关注页面进行项目完工进度确认',
                        okText:'确定',
                        onOk: () => {
                            location.href = '/#/home/myFocus';
                        }
                    });
                    return
                }
                message.success('确认成功');
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    batchConfirmThisSite = (record) => {
        const { date, investigationSiteId } = record;
        this.batchConfirmAllSite({
            begin: date,
            end: date,
            investigationSiteId,
        });
    }

    batchConfirmAllSite = (params = {}) => {
        const { searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.comfirmUserFteMonthAll,
            data: {
                ...searchParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.completeInvMessage) {
                    message.success(res.completeInvMessage);
                } else if (res.invJde) {
                    message.success(res.invJde);
                } else if (res.siteJde) {
                    message.success(res.siteJde);
                } else if (res.endTimeOverComment) {
                    message.success(res.endTimeOverComment);
                } else if (res.siteContractRelate) {
                    message.error(res.siteContractRelate);
                }  else if (res.pmConfirmPercent && res.pmConfirmPercent == '项目完工进度未确认，无法确认工时！'){
                    Modal.warning({
                        content: '部分项目的“截止本月末完工%”=100%，请至我的关注页面进行项目完工进度确认',
                        okText:'确定',
                        onOk: () => {
                            location.href = '/#/home/myFocus';
                        }
                    })
                } else if (res.visitNoHourError) {
                    message.info(res.visitNoHourError);
                } else if (res.noData) {
                    message.success(res.noData);
                } else if (res.success) {
                    message.success(res.success);
                } else if (res.siteContractRelate){
                    message.error(res.success);
                } 
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getRender = (text, record) => {
        const { dateValue } = record;
        if (dateValue !== '合计' && dateValue !== '总计') {
            return text || '-';
        }
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { pagination: { current, pageSize, total } } = this.state;
        const { curRole, curEmployeeCode } = sessionStorage;
        const columns = [{
            title: '工作日期',
            dataIndex: 'dateValue',
            key: 'dateValue',
            fixed: 'left',
            sorter: true,
            width: 90,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: 'left',
            sorter: true,
            width: 90,
            render: this.getRender,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: 'left',
            sorter: true,
            width: 160,
            render: this.getRender,
        }, {
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '录入者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
        }, {
            title: '工作类型',
            dataIndex: 'crcRequirementInfoTypeShow',
            key: 'crcRequirementInfoTypeShow',
            width: 80,
        }, {
            title: '用时/FTE',
            dataIndex: 'manHourValueShow',
            key: 'manHourValueShow',
            width: 100,
            render: (text, record) => {
                const { afterStartShow } = record;
                return text ?
                <Tooltip overlayStyle={{ width: 160 }} placement="top" title={`启动后工时/FTE：${afterStartShow}`}> 
                    <span style={{
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        display: 'flex',
                        paddingLeft: 10,
                        alignItems: 'center',
                    }} >
                        {text}
                    </span>
                </Tooltip> 
                : ''
            } 
        }, {
            title: (
                <span>
                    每个标访工时数
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'每个标访工时数=截止当月累计确认FTE/截止当月累计确认标准访视数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'perVisitFte',
            key: 'perVisitFte',
            width: 120,
        }, {
            title: '实际访视数',
            dataIndex: 'visitAmount',
            key: 'visitAmount',
            width: 80,
        }, {
            title: '访视数分配系数',
            dataIndex: 'assignWeight',
            key: 'assignWeight',
            width: 110,
            render: (text, record) => {
                const { status, dateValue, isComfirm, pmEditFlag } = record;
                const { isConfigMainCrcDate, currentDate } = this.state;
                const isCurrentMonth = currentDate == dateValue; //工作时间是否是本月
                return (
                    (dateValue !== '总计') && (
                        (text || text === 0) ?
                            <span>
                                {`${(text * 100).toFixed(2)} %`}
                                {
                                    (dateValue !== '合计' && pmEditFlag && status == 'VERIFY' && isCurrentMonth) &&
                                    <Icon style={{marginLeft:10,color:'#23cb23',cursor:'pointer'}} onClick={()=> this.canEditByInvStatus(() => this.showConfigMainCrc(record, 'edit'))} type="edit" />
                                }
                            </span>
                        :
                            <span>
                                {'-'}
                                {
                                    (dateValue !== '合计' && pmEditFlag && status == 'VERIFY' && isCurrentMonth) &&
                                    <Icon style={{marginLeft:10,color:'#23cb23',cursor:'pointer'}} onClick={()=> this.canEditByInvStatus(() => this.showConfigMainCrc(record, 'edit'))} type="edit" />
                                }
                            </span>
                    )
                )
            },
        }, {
            title: '标准访视数',
            dataIndex: 'visitStandardAmount',
            key: 'visitStandardAmount',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'statusShow',
            key: 'statusShow',
            width: 110,
        }];
        if (curRole === 'CRC' || curRole == 'PA' || curRole == 'PM') {
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 130,
                render: (text, record) => {
                    const { status, dateValue, isComfirm, memoryStatus, employeeCode, investgationSiteUserFteMonthSummaryId } = record;
                    if (curRole === 'CRC') {
                        return (
                            (dateValue === '合计' && dateValue !== '总计') && (
                                memoryStatus === 'ACTIVE' && status != 'VERIFY' ?
                                    <a onClick={()=> this.canEditByInvStatus(() => this.markModifyComplete(record))}>标记修改完成</a>
                                :
                                    '-'
                            )
                        );
                    } else if (curRole == 'PA') {
                        return (
                            (dateValue === '合计' && dateValue !== '总计') && (
                                status != 'VERIFY' && isComfirm == "1" ?
                                    (curEmployeeCode == employeeCode && memoryStatus === 'ACTIVE' && status != 'VERIFY') ?
                                        <a onClick={()=> this.canEditByInvStatus(() => this.markModifyComplete(record))}>标记修改完成</a>
                                    :
                                        '-'
                                :
                                    '-'
                            )
                        );
                    } else if (curRole == 'PM') {
                        if (dateValue === '合计') {
                            return (
                                <Popconfirm
                                    title={<div>是否确定批量确认此中心的工时？<br/>工时记录确认后，不能再修改</div>}
                                    onConfirm={()=> this.canEditByInvStatus(() => this.batchConfirmThisSite(record))}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <a>批量确认</a>
                                </Popconfirm>
                            );
                        } else if (dateValue === '总计') {
                            if (Math.ceil(total / pageSize) === current) {
                                return (
                                    <Popconfirm
                                        title={<div>是否确定批量确认所有的未确认工时？<br/>工时记录确认后，不能再修改</div>}
                                        onConfirm={()=> this.canEditByInvStatus(() => this.batchConfirmAllSite())}
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <a>批量确认</a>
                                    </Popconfirm>
                                );
                            }
                        } else {
                            const { crcAmount, mainCrc, assignWeight, manHourValue, isShowMainCrc, investigationSiteCodeShow, canSetMainCrc } = record;
                            return (
                                status != 'VERIFY' && isComfirm == "1" ?
                                    <span>
                                        {
                                            (crcAmount > 1 && isShowMainCrc === 1) && (
                                                <span>
                                                    {
                                                        (!assignWeight && canSetMainCrc) ?
                                                            manHourValue > 0 ?
                                                                <a onClick={()=> this.canEditByInvStatus(() => this.showConfigMainCrc(record, 'add'))}>设置主要CRC</a>
                                                            :
                                                                <a disabled={true}>设置主要CRC</a>
                                                        :
                                                            mainCrc ?
                                                                <Popconfirm title="确认取消设置为主要CRC？" onConfirm={()=> this.canEditByInvStatus(() => this.cancelConfig(record))} okText="确定" cancelText="取消">
                                                                    <a>取消设置为主要CRC</a>
                                                                </Popconfirm>
                                                            :
                                                                <a disabled={true}>取消设置为主要CRC</a>
                                                    }
                                                    <span className="ant-divider" />
                                                </span>
                                            )
                                        }
                                        <Popconfirm
                                            title={<div>是否确定此操作?工时记录确认后，不能再修改<br/>{investigationSiteCodeShow !== '-' && <span style={{color:'#F00'}}>强烈建议：同一家中心批量确认工时！</span>}</div>}
                                            onConfirm={()=> this.canEditByInvStatus(() => this.confirm(investgationSiteUserFteMonthSummaryId))}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <a>确认</a>
                                        </Popconfirm>
                                        <span className="ant-divider" />
                                        <a onClick={()=> this.canEditByInvStatus(() => this.showInformModify(record))}>通知修改</a>
                                    </span>
                                :
                                    memoryStatus === 'ACTIVE' && status != 'VERIFY' ?
                                        <a onClick={()=> this.canEditByInvStatus(() => this.markModifyComplete(record))}>标记修改完成</a>
                                    :
                                        '-'
                            );
                        }
                    }
                },
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showInformModify = (record) => {
        this.informModifyRef.show(record);
    }

    showConfigMainCrc = (record, type) => {
        this.configMainCrcRef.show(record, type);
    }

    updateAssignWeight = (record) => {
        this.updateAssignWeightRef.show(record, 'edit');
    }

    handleSwitchChange = (checked) => {
        const day = moment().date();
        if (day < 27 || day > 29) {
            return message.warning('仅27～29日可以操作');
        }
        if (checked) {
            message.warning('待工时补录完成后，确认工时前请确认是否需要重新配置访视分配系数');
        }
        this.setState({
            checked,
        }, () => {
            this.postOpenSwitch();
        });
    }

    postOpenSwitch = () => {
        const { checked } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.execute.openSwitch,
            data: {
                openFlag: checked,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, maxMonth, currentDate, date, flag, checked } = this.state;
        const { invState, curRole } = sessionStorage;
        const isCenter = sessionStorage.getItem('investigationSiteName') == '中心汇总';
        return (
            <div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    currentDate={currentDate}
                    date={date}
                    buttons={[
                        curRole != 'CRC' && <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                        // (invState == 2 && curRole == 'PM') && <Button key="updateAssignWeight" type="primary" onClick={this.updateAssignWeight}>修改访视数分配系数</Button>,
                    ]}
                />
                <div style={{ marginBottom: 15 }}>
                    <span style={{ color: 'red', marginRight: 20 }}>工时添加/修改/删除后，工时数据会在30分钟后同步到汇总记录</span>
                    {
                        flag && isCenter && 
                        <span>
                            <label className="" style={{ marginRight: 10 }}>是否开启补录工时</label>
                            <span className="">
                                <Switch size="small" checked={checked} onChange={this.handleSwitchChange} />
                            </span>
                        </span>
                    }
                    
                </div>
                <Spin spinning={loading}>
                    <TableC
                        data={data}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </Spin>
                <InformModify loadData={this.loadData} ref={el => this.informModifyRef = el} />
                <ConfigMainCrc ref={el => this.configMainCrcRef = el} loadData={this.loadData} maxMonth={maxMonth} />
                <UpdateAssignWeight ref={el => this.updateAssignWeightRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Summary;


// WEBPACK FOOTER //
// ./src/components/execute/manHour/Summary.js